export const state = {
  iconCache: {},
}

export const getters = {
  iconCache: (state) => state.iconCache,
}

export const mutations = {
  cacheIcon(state, data) {
    state.iconCache[data.path] = data.icon
  },
}
